export const CHANGE_DISPLAY_MODE = 'LIBRARY_CHANGE_DISPLAY_MODE';
export const CHANGE_SORT_ORDER = 'LIBRARY_CHANGE_SORT_ORDER';
export const CHANGE_FILTER_BY = 'LIBRARY_CHANGE_FILTER_BY';
export const SET_SEARCH_STRING = 'LIBRARY_SET_SEARCH_STRING';

export const FETCH_LIBRARY_REQUEST = 'LIBRARY_FETCH_REQUEST';
export const FETCH_LIBRARY_FAILURE = 'LIBRARY_FETCH_FAILURE';
export const FETCH_LIBRARY_SUCCESS = 'LIBRARY_FETCH_SUCCESS';



// WEBPACK FOOTER //
// ./src/constants/library.js